
import Icon from '@/components/UntitledUI/Icon.vue'
import FTabs from './FTabs.vue'
import FTab from './FTab.vue'
import LinkIcon from './Icons/LinkIcon.vue'
import LoginRequired from './LoginRequired.vue'
import TagVerticalWrapper from './TagVerticalWrapper.vue'

export default {
    name: 'FileInfo',
    components: {
        LoginRequired,
        Icon,
        FTab,
        FTabs,
        LinkIcon,
        TagVerticalWrapper
    },
    props: {
        meta: Object
    },
    inject: [
        'isLogged',
        'toast'
    ],
    data () {
        return {
            showFullSummary: false,
            showFullDescription: false,
            lastToastTime: 0,
            isMinWidth: window.innerWidth <= 639
        }
    },
    computed: {
        tagsWithCountOrLink () {
            return this.meta.tags.filter(tag => tag.counter !== undefined || tag.link !== undefined)
        }
    },
    mounted () {
        window.addEventListener('resize', this.checkWidth)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.checkWidth)
    },
    methods: {
        checkWidth () {
            this.isMinWidth = window.innerWidth <= 639
        }
    }
}
